import { publicAxios as axios } from "../../config/axios";
import endpoints from "../../utils/endpoints";
import globalConstant from "../../utils/constants";

export type PaymentTestMode = "safe" | "paid" | "proceed" | "settle" | "reset";

export interface PaymentTestInfo {
  estimateNo: string;
  enquiryNo: string;
  customerCode?: string;
  isTestCustomer: boolean;
  expiresAt?: string;
  expired: boolean;
  readySplits: number;
  hasCbo: boolean;
  splitStatuses: string[];
  link: {
    status: string;
    amount?: number;
    confirmed: boolean;
    hasCboDecision: boolean;
  } | null;
  problems: string[];
  runnable: Record<PaymentTestMode, boolean>;
}

export interface PaymentTestCheck {
  section: string;
  name: string;
  ok: boolean;
  detail?: string;
}

export interface PaymentTestReport {
  mode: PaymentTestMode;
  estimateNo: string;
  customerCode?: string;
  startedAt: string;
  durationMs: number;
  passed: number;
  failed: number;
  checks: PaymentTestCheck[];
  alerts: string[];
  notes: string[];
}

const authHeaders = () => ({
  Authorization: localStorage.getItem(globalConstant.AUTH_TOKEN),
});

const estimatePaymentTesterServices = {
  async getInfo(estimateNo: string): Promise<PaymentTestInfo> {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.estimatePaymentTest(estimateNo),
      headers: authHeaders(),
    });
    return response.data;
  },

  async run(
    estimateNo: string,
    mode: PaymentTestMode,
  ): Promise<PaymentTestReport> {
    const response = await axios({
      method: globalConstant.POST,
      url: endpoints.estimatePaymentTest(estimateNo),
      headers: authHeaders(),
      data: { mode },
    });
    return response.data;
  },
};

export default estimatePaymentTesterServices;
